import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

const SearchRoute = (
  <Route
    key="Search"
    path="/search"
    component={
      Loadable({
        loader: () => import(
          /* webpackChunkName: "Search" */
          './containers/SearchBetaContainer'
        ),
        loading: () => null
      })
    }
  />
);

export default SearchRoute;
